import { IAutomationFilters, IAutomationBlueprint } from './Automation';

export interface IAutomationRevision {
  id: string;
  automationId: string;
  revision: number;
  blueprint: IAutomationBlueprint;
  metadata: IAutomationRevisionMetadata;
  createdDate: Date;
  updatedDate: Date;
}

export interface IAutomationRevisionMetadata {}

export interface IAutomationRevisionFilters {
  revision?: number;
  automation?: IAutomationFilters;
}

export interface IAutomationRevisionCreateOptions {
  publish?: boolean;
}
